import axios from 'axios'
import wrappers from '../utils/wrappers'

const url = `${import.meta.env.VITE_API_URL}/v1/help-assistant`

export type HelpAssistantNavigateAction = {
  type: 'navigate'
  navigateId: string
  label: string
  routeName: string
  query?: Record<string, string>
  requiresProject: boolean
  openRightPanel?: boolean
}

export type HelpAssistantSuggestionAction = {
  type: 'start_suggestion'
  label: string
  prefillMessage: string
}

export type HelpAssistantBugReportAction = {
  type: 'start_bug_report'
  label: string
  prefillMessage: string
}

export type HelpAssistantAction =
  | HelpAssistantNavigateAction
  | HelpAssistantSuggestionAction
  | HelpAssistantBugReportAction

export type HelpAssistantChatResponse = {
  assistantChatId: string
  reply: string
  topicIdsUsed?: string[]
  actions: HelpAssistantAction[]
  usage?: {
    userRemainingToday: number
    userLimitToday: number
  }
}

export default {
  chat(params: {
    assistantChatId?: string
    message: string
    context: {
      routePath: string
      routeName?: string
      routeQuery?: Record<string, unknown>
      projectId?: string
      chapterId?: string
      projectType?: string
      tab?: string
      detail?: string
      display?: 'desktop' | 'mobile'
      locale?: string
    }
  }): Promise<HelpAssistantChatResponse> {
    return axios
      .post(`${url}/chat`, params, { timeout: 30000 })
      .then((response: any) => {
        const envelope = wrappers.handleEscribonautaResponse(response)
        return envelope.data as HelpAssistantChatResponse
      })
      .catch((error: any) => {
        const status = error?.response?.status || error?.response?.data?.code
        const errorCode =
          error?.response?.data?.errorCode || error?.response?.data?.data?.errorCode
        let message = 'No se pudo obtener ayuda automática'
        if (status === 429 || errorCode === 'HELP_USER_LIMIT') {
          message = 'Has alcanzado el límite de mensajes de ayuda. Inténtalo más tarde.'
        } else if (
          status === 503 ||
          errorCode === 'HELP_GLOBAL_LIMIT' ||
          errorCode === 'HELP_PROVIDER_UNAVAILABLE' ||
          errorCode === 'HELP_DISABLED'
        ) {
          message = 'La ayuda automática no está disponible temporalmente.'
        }
        return wrappers.handleEscribonautaError(error, message)
      })
  },
}
